import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BaseHttpService } from './base-http.service';

export interface StaleSubscription {
  type: 'dashboard' | 'insight';
  id: number;
  title: string;
  emailTo: string;
  frequency: 'week' | 'month';
  dashboardShareId?: number;
  staleReason: string;
  staleAt: string;
  staleId: string;
}

@Injectable()
export class StaleSubscriptionsService extends BaseHttpService {

  constructor(public http: HttpClient) {
    super(http);
  }

  getStaleSubscriptions(): Observable<any> {
    return this.get('dashboard/stale-subscriptions');
  }

  deleteStaleSubscription(subscription: StaleSubscription): Observable<any> {
    return this.delete(`dashboard/stale-subscriptions/${subscription.type}/${subscription.id}`, subscription.staleId);
  }
}
